#import '../fragments/stage-lead-user-assignment-data-fragment.graphql'

query GetUserAssignmentsForStage($stageId: ID!) {
    stage(id: $stageId) {
        id
        ...StageLeadUserAssignmentData
    }
}
